import Style from "../scss/text.module.scss";

export function TitleH6Component(props) {
    return (
        <h6 className={`${Style.h3} ${props.styleGroup}`}>{props.children}</h6>
    );
}